var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMachineUserTransactions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeMiterlimit: 10,
    strokeWidth: 12,
    d: "M96 120c16.569 0 30-13.431 30-30 0-16.569-13.431-30-30-30-16.569 0-30 13.431-30 30 0 16.569 13.431 30 30 30Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M47.85 149.55A53.993 53.993 0 0 1 96 119.996c9.972 0 19.75 2.761 28.248 7.978a53.991 53.991 0 0 1 19.902 21.576"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M167.1 84.675c.606 3.745.907 7.532.9 11.325a72.003 72.003 0 0 1-86.046 70.617 72.002 72.002 0 0 1-52.473-98.17A72 72 0 0 1 96 24a69.982 69.982 0 0 1 11.325.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m159 44 5 4.5-5 4.5m-20-4h24m-20-9-5-4.5 5-4.5m20 4h-24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C71B8",
    d: "M150.5 66c13.531 0 24.5-10.969 24.5-24.5S164.031 17 150.5 17 126 27.969 126 41.5 136.969 66 150.5 66Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M150.5 66c13.531 0 24.5-10.969 24.5-24.5S164.031 17 150.5 17 126 27.969 126 41.5 136.969 66 150.5 66Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineUserTransactions);
export default __webpack_public_path__ + "static/media/MachineUserTransactions.8473815c490ab7ca20b88b3f01c0687f.svg";
export { ForwardRef as ReactComponent };